import { rgba } from 'polished';
import { swatches } from './swatches';
const text = {
    '100': swatches.warm['700'],
    '200': swatches.warm['800'],
    '300': swatches.warm['1000'],
    light: swatches.warm['0'],
    success: swatches.green['500'],
    danger: swatches.red['500'],
};
const surface = {
    primary: swatches.warm['0'],
    secondary: swatches.warm['25'],
    sunken: swatches.warm['50'],
    raised: swatches.warm['0'],
    overlay: swatches.warm['0'],
    inverse: swatches.warm['1000'],
    inverseRaised: swatches.warm['900'],
    backdrop: rgba(swatches.warm['1000'], 0.55),
};
const foreground = {
    primary: swatches.warm['1000'],
    secondary: swatches.warm['800'],
    tertiary: swatches.warm['600'],
    muted: swatches.warm['500'],
    disabled: swatches.warm['400'],
    inverse: swatches.warm['0'],
    inverseDim: swatches.warm['400'],
};
const border = {
    default: swatches.warm['100'],
    subtle: swatches.warm['75'],
    strong: swatches.warm['500'],
};
const action = {
    primary: {
        default: swatches.warm['1000'],
        hover: swatches.warm['900'],
        active: swatches.warm['800'],
        disabled: swatches.warm['100'],
    },
    secondary: {
        default: swatches.warm['0'],
        hover: swatches.warm['50'],
        active: swatches.warm['100'],
        disabled: swatches.warm['25'],
    },
};
const feedback = {
    success: {
        surface: swatches.green['50'],
        border: swatches.green['100'],
        text: swatches.green['700'],
    },
    warning: {
        surface: swatches.yellow['50'],
        border: swatches.yellow['100'],
        text: swatches.yellow['900'],
    },
    danger: {
        surface: swatches.red['50'],
        border: swatches.red['100'],
        text: swatches.red['700'],
    },
    info: {
        surface: swatches.blue['50'],
        border: swatches.blue['100'],
        text: swatches.blue['500'],
    },
};
const focus = {
    ring: swatches.warm['200'],
    border: swatches.warm['1000'],
};
export const semantic = {
    surface,
    foreground,
    border,
    action,
    feedback,
    focus,
    text,
};
